<template>
    <header id="masthead" role="banner">
    <transition name="slide-fade">
        <div class="site-header" v-if="loaded" :class="{'site-header--toggle': expandMenu}">
            <div class="site-header__row">
                <div class="site-header__branding">
                  <router-link class="logo-wrapper" to="/" :class="{'logo-wrapper--light': themeColor === '#fff'}">
                    <img class="logo-wrapper" :src="logo" />
                    <!-- TODO: Look at how the logo is styled -->
                  </router-link>
                </div>
                <nav class="site-header__nav" id="site-navigation">
                    <div class="navigation">
                        <ul class="navigation__list">
                            <li class="navigation__link-container" v-for="(item, index) in menu" :key="index">
                            <cmslink v-bind:link="item" class="navigation__link" :on-click="closeMenu"/>
                              <ul class="navigation__sublist" v-if="item.children.length">
                                <li class="navigation__sub-link" v-for="(subitem, index) in item.children" :key="index">
                                  <cmslink v-bind:link="subitem" class="navigation__link" :on-click="closeMenu"/>
                                </li>
                              </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
                <button class="site-header__hamburger hamburger-button" aria-controls="primary-menu" v-bind:aria-expanded="expandMenu" v-on:click="toggleMenu">
                  <span class="hamburger-button__stripe hamburger-button__stripe--1"></span>
                  <span class="hamburger-button__stripe hamburger-button__stripe--2"></span>
                  <span class="hamburger-button__stripe hamburger-button__stripe--3"></span>
                </button>
              <div class="scroll-post__horizontal-line scroll-post__horizontal-line--top"></div>
            </div>
        </div>
     </transition>
    </header>
</template>

<script>
    import Vue from 'vue'
    import vueDebounce from 'vue-debounce'
    Vue.use(vueDebounce);
    var j = jQuery.noConflict();

    export default {

        mounted() {
            this.getMenu();
        },
        
        data() {
            return {
                menu: [],
                logo: rtwp.header_logo,
                logoMobile: rtwp.mobile_logo,
                loaded: false,
                expandMenu: false,
            };

        },
        computed: {
          themeColor() {
            return this.$store.state.themeColor !== 'white' ? '#000' : '#fff';
          },
        },
        methods: {
            toggleMenu() {
              this.expandMenu = !this.expandMenu;
            },
            closeMenu() {
              this.expandMenu = false;
            },
            getMenu: function () {
                const vm = this;
                
                vm.$http
                    .get("wp-api-menus/v2/menu-locations/primary-menu")
                    .then(res => {
                        vm.menu = res.data;
                        vm.loaded = true;
                       
                    })
                    .catch(res => {
                        console.log(`Something went wrong : ${ res }`);
                    });
            
            },
        },
        watch: {
          '$route' (to, from) {
            this.getMenu();
          }
        }
    };


</script>

<style lang="scss">
    @import "./style";
    
</style>